import React from 'react';
import type { UpstreamChanges } from '../types/playbook.types';

interface UpstreamBadgeProps {
  upstream?: UpstreamChanges;
  onClick?: () => void;
}

const UpstreamBadge: React.FC<UpstreamBadgeProps> = ({ upstream, onClick }) => {
  if (!upstream) return null;

  if (!upstream.hasUpstreamChanges) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-medium text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
        Up to date v{upstream.sourceVersion}
      </span>
    );
  }

  const changeCount = upstream.diff?.summary
    ? upstream.diff.summary.statusesAdded + upstream.diff.summary.statusesRemoved +
      upstream.diff.summary.statusesModified + upstream.diff.summary.transitionsAdded +
      upstream.diff.summary.transitionsRemoved + upstream.diff.summary.transitionsModified
    : 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-700 hover:bg-amber-100 transition-colors dark:bg-amber-900/30 dark:text-amber-300 dark:hover:bg-amber-900/50"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
      System updated to v{upstream.latestSourceVersion}
      {changeCount > 0 ? ` — ${changeCount} changes` : ''}
    </button>
  );
};

export default UpstreamBadge;
